import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import tool from "./tool";
export default {
  data: function data() {
    return {
      searchVal: "",
      list: [],
      total: 0,
      current: 1,
      // 页码
      perPage: 5,
      rangeBefore: 3,
      rangeAfter: 2,
      timerList: []
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, data, result, i;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.list = [];
              url = "/pjyy-deepexi-product-center/api/v1/product/drug/drugList";
              data = {
                page: _this.current,
                size: _this.perPage,
                condition: _this.searchVal
              };
              _context.next = 5;
              return _this.$getHttpClient().post(url, data);
            case 5:
              result = _context.sent;
              _this.list = result.data.data.list;
              for (i in _this.list) {
                _this.list[i].downType = 1;
                _this.list[i].isShowDown = true;
              }
              _this.total = result.data.data.total;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onSearch: function onSearch() {
      this.current = 1;
      this.getList();
    },
    handleChange: function handleChange(val) {
      this.current = val;
      this.getList();
    },
    //2021-11-03 修改批量打包下载
    goDetail: tool.throttle(function (data) {
      var _this2 = this;
      this.timerList = [];
      this.$buefy.toast.open({
        message: "请稍等！正在下载中",
        type: "is-success",
        position: 'is-bottom'
      });
      var obj = {
        id: data[0].id,
        timer: "timer" + data[0].id
      };
      this.timerList.push(obj);
      this.timerList.forEach(function (element, index) {
        element.timer = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var result, i, _i;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!(element.timer == null)) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                _context2.next = 4;
                return _this2.$getHttpClient().get("/pjyy-deepexi-product-center/api/v1/product/drug/getDownLoadDrugSpeed/" + element.id);
              case 4:
                result = _context2.sent;
                if (result.data.code == 200) {
                  for (i in _this2.list) {
                    if (_this2.list[i].id == result.data.data.productId) {
                      _this2.list[i].speed = result.data.data.speed;
                      _this2.list[i].downType = 1; //下载中
                      _this2.list[i].isShowDown = false;
                    }
                  }
                  if (result.data.data.speed == 100 && element.id == result.data.data.productId) {
                    console.log("下载完成清除定时器：" + element.timer, "当前索引：" + index);
                    clearInterval(element.timer);
                    element.timer = null;
                    delete _this2.timerList[index];
                    window.open(result.data.data.path, '_self');
                    // window.location.href = result.data.data.path;
                  }
                } else {
                  console.log("下载失败清除定时器：" + element.timer, "当前索引：" + index);
                  clearInterval(element.timer);
                  element.timer = null;
                  delete _this2.timerList[index];
                  for (_i in _this2.list) {
                    if (_this2.list[_i].id == element.id) {
                      _this2.list[_i].downType = 0; //下载失败
                      _this2.list[_i].isShowDown = false;
                    }
                  }
                }
                _this2.$forceUpdate();
              case 7:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })), 2000);
      });
      // window.sessionStorage.setItem("dataDownLoadDetail", JSON.stringify(data));
      // this.$router.push({
      //   path: `data-download-detail`
      // });
    })
  },
  //2021-11-03修改
  beforeDestroy: function beforeDestroy() {
    var _this3 = this;
    this.timerList.forEach(function (res, index) {
      clearInterval(res.timer);
      res.timer = null;
      delete _this3.timerList[index];
      console.log("页面销毁清除定时器：" + res.timer, "当前索引：" + index);
    });
  }
};